const ACTIONS = {
    RESOURCES_FILTERS_REQUEST_SUCCESS: 'RESOURCES_FILTERS_REQUEST_SUCCESS',
    RESOURCES_SET_ACTIVE_FILTER: 'RESOURCES_SET_ACTIVE_FILTER'
};

/* initial state */
const initialState = {
    filters: null,
    activeFilter: null
};

/* reducer */
export default (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.RESOURCES_FILTERS_REQUEST_SUCCESS:
            return { ...state, filters: action.filters };
        case ACTIONS.RESOURCES_SET_ACTIVE_FILTER:
            return { ...state, activeFilter: action.filter };
        case ACTIONS.RESOURCES_SET_ACTIVE_FILTER_PAGE: {
            return { 
                ...state, 
                filters: { 
                    ...state.filters, 
                    [action.filterId]: {
                        ...state.filters[action.filterId],
                        page: action.page
                    }
                }
            };
        }
        default:
            return state;
    }
};

/* action creators */
export const setFilters = filters => ({
    type: ACTIONS.RESOURCES_FILTERS_REQUEST_SUCCESS,
    filters
});

export const setActiveFilter = filter => ({
    type: ACTIONS.RESOURCES_SET_ACTIVE_FILTER,
    filter
});


